import { TranslateLike } from './helper';
import { getEnumValueLabel } from './helper';

const SUBSCRIPTION_BILLING_CYCLE_KEY_MAP: Record<Pay.DurationNum, string> = {
  0: 'domain.subscription.billingCycle.notChange',
  1: 'domain.subscription.billingCycle.monthly',
  3: 'domain.subscription.billingCycle.quarterly',
  6: 'domain.subscription.billingCycle.sixMonths',
  12: 'domain.subscription.billingCycle.annual',
};

export const getSubscriptionBillingCycleLabel = (t: TranslateLike, durationNum?: Pay.DurationNum) =>
  getEnumValueLabel(t, durationNum, SUBSCRIPTION_BILLING_CYCLE_KEY_MAP);
